<template>
    <div class="sales-manage">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="商品名称">
                <el-select v-model="formInline.proName" filterable placeholder="请选择商品">
                    <el-option
                            v-for="item in productData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.name">
                    </el-option>
                </el-select>

            </el-form-item>
            <el-form-item label="所属仓">
                <el-select v-model="formInline.warehouseId" filterable placeholder="请选择仓库">
                    <el-option
                            v-for="item in wareHouseList"
                            :key="item.warehouseId"
                            :label="item.warehouseName"
                            :value="item.warehouseId">
                    </el-option>
                </el-select>

            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="getList">查询</el-button>
                <el-button type="success" @click="syncEdbOrder">订单同步至EDB</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="proName" label="商品名称"></el-table-column>
            <el-table-column prop="warehouseName" label="所属仓"></el-table-column>
            <el-table-column prop="salesNum" label="可售卖量" width="240">
                <template slot-scope="scope">
                    <el-input-number v-if="scope.row.id==selectId" v-model="scope.row.salesNum" :min="0" size="mini"></el-input-number>
                    <template v-else>
                        {{scope.row.salesNum}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="proDw" label="单位/盒" width="100"></el-table-column>
            <el-table-column label="操作" fixed="right" width="120" >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="danger" v-if="scope.row.id==selectId" size="mini" @click="saveSalesNum(scope.row.proId,scope.row.salesNum,scope.row.id,scope.row.warehouseId)">保存</el-button>
                        <el-button type="primary" v-else size="mini" @click="handleEditSales(scope.row.id)" :disabled="selectId!==''">修改</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getSalesManageNumList,syncEdbOrder,getItems,saveSalesManageNumItem,delSalesManageNumItem} from '@/api/api';
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                loading:false,
                formInline:{
                    proName:'',
                    proState:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    warehouseId:''
                },
                productData:[],
                selectId:'',
                wareHouseList:[{
                    warehouseId:'1037595826996514816',
                    warehouseName:'北京仓'
                },{
                    warehouseId:'1069807551659380736',
                    warehouseName:'上海仓'
                }]
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            getItems({itemType:4}).then((res) => {
                console.log(res);
                this.productData = res.data;
            });
        },

        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                this.selectId = '';
                getSalesManageNumList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.listData = res.data.list;
                })
            },
            syncEdbOrder(){
                syncEdbOrder(this.formInline).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },

            //修改事件
            handleEditSales(id){
                this.selectId = id
            },
            //保存事件
            saveSalesNum(proId,Num,id,wareId){
                this.loading = true;
                let _this = this;
                saveSalesManageNumItem({proId:proId,salesNum:Num,id:id,warehouseId:wareId}).then((res) => {
                    this.loading = false;
                    console.log(res)
                    if(res.data.status==200){
                        _this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        _this.selectId = '';
                    }else{
                        _this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .sales-manage{
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/views/salesManage/salesNum.vue